import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import locale from "csi/locale";
import { TabScrollButton } from "designSystem/components/tabs/TabScrollButton";
import { Button, ConfirmDialog, FlexColumn, FlexRowCenter, IconButton, Menu, MenuItem, Tab, TabPanel, Tabs } from "designSystem/index";
import { POPOVER_BOTTOM_START } from "designSystem/styles/popover-positions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import BaseCompositionMainPanel from "./BaseCompositionMainPanel";
import { BASE_COMPOSITION, useBaseCompositionStore } from "./BaseCompositionStore";
import css from "./MainBaseCompositionData.module.css";
import { SalesRegionException } from "./SalesRegionException";
import { C8Node } from "csi/typings";

interface MainBaseCompositionDataProps { }

const MainBaseCompositionData: FunctionComponent<MainBaseCompositionDataProps> = observer(function MainBaseCompositionData(props) {
	const {
		addSalesRegionException,
		disableAddSalesRegionException,
		handleMenuClick,
		handleMenuClose,
		menuAnchorEl,
		onCancelDeleteConfirm,
		onClickDeleteConfirm,
		onCloseDeleteConfirm,
		onConfirm,
		onTabChange,
		salesRegionExceptionNames,
		salesRegionExceptions,
		salesRegionDropdown,
		salesRegionToDeleteName,
		showSalesRegionConfirmCloseWindow,
		tabIndex,
		onClickConfirmOnSaveConfirmationPopup,
		onCloseSaveConfirmPopup,
		openOnConfirmDailog,
	} = useBaseCompositionStore();

	return (
		<FlexColumn>
			<FlexRowCenter className={css.tabCase}>
				<FlexRowCenter minWidth={0}>
					<Tabs
						ScrollButtonComponent={TabScrollButton}
						className={css.tabMenu}
						onChange={onTabChange}
						scrollButtons="auto"
						value={tabIndex}
						variant="scrollable"
						visibleScrollbar={false}
					>
						{salesRegionExceptions.map((salesRegionException: SalesRegionException, index: number) => {
							const dataCsiAutomation = !salesRegionException.isBaseComposition ? `tab-${salesRegionException.key}` : "tab-BaseComposition";

							return (
								<Tab
									data-csi-automation={dataCsiAutomation}
									icon={!salesRegionException.isBaseComposition ? (
										<>
											<IconButton
												className={css.cancelIconButton}
												data-csi-automation="button-RemoveSalesRegionException"
												onClick={onClickDeleteConfirm(salesRegionException.key)}
											>
												<CancelIcon
													className={css.cancelIcon}
												/>
											</IconButton>
										</>
									) : null}
									iconPosition="end"
									key={salesRegionException.key}
									label={!salesRegionException.isBaseComposition ? salesRegionException.name : locale.resource(BASE_COMPOSITION)}
								/>
							);
						})}
					</Tabs>
				</FlexRowCenter>
				{salesRegionExceptionNames.length !== 0 && (
					<Button
						className={css.addSalesRegionButton}
						data-csi-automation="button-AddSalesRegionException"
						design="outline"
						disabled={disableAddSalesRegionException}
						onClick={handleMenuClick}
						res="SalesRegionException"
						startIcon={<AddIcon />}
					/>
				)}
				<Menu
					anchorEl={menuAnchorEl}
					aria-labelledby="sales-region-exception-button"
					id="sales-region-exception-menu"
					onClose={handleMenuClose}
					open={menuAnchorEl !== null}
					{...POPOVER_BOTTOM_START}
				>
					{salesRegionDropdown.map((srNode: C8Node, index: number) => {
						const srName = srNode.$Name;
						const srUrl = srNode.$URL;
						const addSalesRegionOnClick = () => addSalesRegionException(srName, srUrl, 0, true);
						return <MenuItem onClick={addSalesRegionOnClick} text={srName} />;
					})}
				</Menu>
			</FlexRowCenter>
			{salesRegionExceptions.map((salesRegionException: SalesRegionException, index: number) => {
				return (
					<TabPanel
						flexGrow={1}
						height="90%"
						index={index}
						selectedTabIndex={tabIndex}
					>
						<BaseCompositionMainPanel salesRegionException={salesRegionException} />
					</TabPanel>
				);
			})}
			<ConfirmDialog
				category="error"
				confirmRes="BUTTON_CONT"
				messageRes="SaveConfirmationZeroPercentNotNestUnder"
				onClose={onCloseSaveConfirmPopup}
				onConfirm={onClickConfirmOnSaveConfirmationPopup}
				open={openOnConfirmDailog}
				showClose
				titleRes="SavePromptZeroPercentNotNestUnder"
			/>
			<ConfirmDialog
				category="error"
				confirmRes="Delete"
				messageRes="DeleteSalesRegionExceptionMessage"
				messageResParams={salesRegionToDeleteName}
				onCancel={onCancelDeleteConfirm}
				onClose={onCloseDeleteConfirm}
				onConfirm={onConfirm}
				open={showSalesRegionConfirmCloseWindow}
				titleRes="DeleteSalesRegionException"
			/>
		</FlexColumn>
	);
},
);

export default MainBaseCompositionData;